declare namespace $ {

	type $mol_string__hint_bog_dobro_app_prof_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_dobro_app_prof_2 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_prof['query'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_gallery__items_bog_dobro_app_prof_3 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_prof['Helpers_gallery_items'] >
		,
		ReturnType< $mol_gallery['items'] >
	>
	type $mol_view__sub_bog_dobro_app_prof_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_bog_dobro_app_prof_5 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_prof['helper_description'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_link__uri_bog_dobro_app_prof_6 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_prof['Helper_item_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__click_bog_dobro_app_prof_7 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_prof['Helper_item_open'] >
		,
		ReturnType< $mol_link['click'] >
	>
	type $mol_link__title_bog_dobro_app_prof_8 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_bog_dobro_app_prof_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_card__sub_bog_dobro_app_prof_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['sub'] >
	>
	export class $bog_dobro_app_prof extends $mol_page {
		query( next?: string ): string
		Search( ): $mol_string
		Helpers_gallery_items( ): readonly($mol_view)[]
		Helpers_gallery( ): $mol_gallery
		Helper_item_uri( id: any): string
		Helper_item_open( id: any, next?: any ): any
		helper_title( id: any): string
		Helper_title_view( id: any): $mol_view
		helper_description( id: any): string
		Helper_descr_view( id: any): $mol_text
		Helper_link( id: any): $mol_link
		title( ): string
		body( ): readonly(any)[]
		Helper_item( id: any): $mol_card
	}
	
}

//# sourceMappingURL=prof.view.tree.d.ts.map